import { SourcingService } from 'api-clients/monolith';

/* eslint-disable camelcase */
export interface ValidateSourcingPurchasesParams {
  channel_slug: string;
  start_date: string;
  end_date: string | null;
  opening_ids: string[];
}
/* eslint-enable camelcase */

export function validateSourcingPurchases(
  params: ValidateSourcingPurchasesParams,
) {
  return SourcingService.postInternalApiSourcingSourcingPurchasesValidateSourcingPurchases(
    params,
  );
}
